import Markdown from 'react-markdown'
import { useEffect } from 'react';

const AccessibilityStatement = () => {

  const markdown = `# Accessibility Statement for uCheckly

  We are committed to ensuring that our app is accessible to all users, including people with disabilities. We follow the accepted standards regarding web and app accessibility and are dedicated to providing an inclusive user experience that allows everyone to use the app equally.
  
  ## Our accessibility efforts include:
  Adapting the app for use with screen readers, including adding accessible descriptions for images and buttons.
  Ensuring easy navigation using a keyboard and other assistive technologies.
  Adjusting colors and text sizes to ensure proper contrast.
  Making unique adjustments for people with hearing, vision, or mobility impairments.
  
  ## Conformance Status
  The Web Content Accessibility Guidelines (WCAG) define requirements for designers and developers to improve accessibility for people with disabilities. It outlines three levels of conformance: Level A, Level AA, and Level AAA. uCheckly is fully conformant with WCAG 2.1 level AA. Fully conformant means that the content fully complies with the accessibility standard without exceptions.
  
  ## Reporting accessibility problems with this app
  We're always looking to improve the accessibility of this app. If you find any problems not listed on this page or think we're not meeting accessibility requirements, Please contact us at: devapp555@outlook.com.
  
  ## Feedback
  If you encounter any accessibility issues or need assistance, we would be happy to hear from you. Please contact us at: devapp555@outlook.com
  
  We aim to respond to feedback within 3 business days.
  
  ## Assessment Approach
  ORGANIZATION has assessed the accessibility of Pcaller through self-evaluation.
  
  Date This statement was created on 07 April 2025 using the W3C Accessibility Statement Generator Tool.

`
  return (
    <>
      <div className="padding-page">

        <Markdown>{markdown}</Markdown>
        </div>
      <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUse'>Terms of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div>
    </>
  );
}

export default AccessibilityStatement;